import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ScrollToTopButton from "@/components/ScrollToTopButton";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
const FAQ = () => {
  const faqs = [
    {
      question: "O HabitFrog é gratuito?",
      answer: "Sim! Você pode usar o HabitFrog gratuitamente com até 3 hábitos ativos. Para recursos avançados como hábitos ilimitados, lagoas compartilhadas e estatísticas detalhadas, oferecemos o plano Pro.",
    },
    {
      question: "Como funciona a gamificação com sapos?",
      answer: "Cada hábito que você cria ganha um sapo virtual. Conforme você completa o hábito diariamente, seu sapo evolui de girino para sapo adulto. Quanto mais consistente você for, mais seu sapo cresce e ganha conquistas!",
    },
    {
      question: "O que são lagoas compartilhadas?",
      answer: "Lagoas são grupos onde você pode acompanhar hábitos junto com amigos, família ou colegas. Vocês podem ver o progresso uns dos outros, criar desafios e se motivar mutuamente.",
    },
    {
      question: "Posso cancelar minha assinatura a qualquer momento?",
      answer: "Sim, você pode cancelar quando quiser. Não há multa ou taxa de cancelamento. Após cancelar, você continua com acesso ao Pro até o final do período pago.",
    },
    {
      question: "Meus dados estão seguros?",
      answer: "Absolutamente. Usamos criptografia de ponta a ponta e seguimos todas as diretrizes da LGPD. Seus dados nunca são vendidos ou compartilhados com terceiros.",
    },
    {
      question: "O app funciona offline?",
      answer: "Sim! Você pode registrar seus hábitos mesmo sem internet. Quando a conexão voltar, os dados são sincronizados automaticamente.",
    },
    {
      question: "Como faço para recuperar minha conta?",
      answer: "Na tela de login, clique em 'Esqueci minha senha'. Enviaremos um link de recuperação para seu e-mail cadastrado.",
    },
    {
      question: "Posso usar o HabitFrog no computador?",
      answer: "Sim! O HabitFrog funciona em qualquer navegador. Acesse pelo celular, tablet ou computador e seus dados estarão sempre sincronizados.",
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Perguntas Frequentes (FAQ) | HabitFrog</title>
        <meta name="description" content="Encontre respostas para as perguntas mais frequentes sobre o HabitFrog. Saiba como funciona a gamificação, planos, lagoas compartilhadas e muito mais." />
        <link rel="canonical" href="https://habitfrog.com/faq" />
      </Helmet>

      <Header />
      <ScrollToTopButton />

      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4">
          <header className="text-center max-w-3xl mx-auto mb-16">
            <h1 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-6">
              Perguntas Frequentes
            </h1>
            <p className="text-xl text-muted-foreground">
              Tudo que você precisa saber sobre o HabitFrog
            </p>
          </header>

          <div className="max-w-3xl mx-auto">
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="bg-card rounded-xl border px-6"
                >
                  <AccordionTrigger className="text-left text-lg font-semibold text-foreground hover:no-underline">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default FAQ;
